<template>
  <el-table
    :data="imports"
    stripe
  >
    <el-table-column type="expand">
      <template v-slot="{ row }">
        <InfoDialog :invoice="row" />
      </template>
    </el-table-column>
    <el-table-column
      label="Filename"
      prop="filename"
      width="300px"
      show-overflow-tooltip
      :formatter="row => getFileName(row) || '-'"
    />
    <el-table-column
      label="Total"
      prop="total_value"
      width="100px"
    />
    <el-table-column
      label="GST"
      prop="gst_value"
      width="100px"
    />
    <el-table-column
      label="Fuel"
      prop="fuel_value"
      width="100px"
    />
    <el-table-column
      label="Carrier Name"
      prop="carrier.name"
      show-overflow-tooltip
    />
    <el-table-column
      label="Status"
      prop="status"
      :formatter="row => getStatus(row.status) || '-'"
    />
    <el-table-column
      label="Date"
      prop="date"
    />
    <el-table-column
      label="Progress"
    >
      <template v-slot="{ row }">
        <el-progress
          v-if="getStatus(row.status) !== 'Error Validating'"
          :text-inside="true"
          :stroke-width="20"
          :percentage="getPercent(row)"
          :status="getType(row)"
        />
        <el-tag
          v-else
          type="danger"
        >
          Error
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column
      label="Actions"
      align="right"
    >
      <template
        slot-scope="scope"
      >
        <el-dropdown
          v-if="!isLoading(scope.$index)"
          split-button
          size="mini"
          @command="handleActionCommand"
          @click="refreshImport(scope.$index)"
        >
          Refresh
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="{ action: resetImport, scope}">
              Reset
            </el-dropdown-item>
            <el-dropdown-item
              divided
              :command="{ action: deleteImport, scope}"
            >
              Cancel
            </el-dropdown-item>
            <el-dropdown-item
              divided
              :command="{ action: downloadImport, scope}"
            >
              Download File
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-spinner v-else />
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import InfoDialog from '@/components/Application/Billing/CarrierInvoices/InfoDialog'

export default {
  components: {
    InfoDialog
  },
  props: {
    imports: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      loading: [],
      infoDialogInstance: undefined,
      infoDialogVisible: false
    }
  },
  methods: {
    tableRowClassName ({ row, rowIndex }) {
      if (row.status === '-1') {
        return 'error-row'
      }
    },
    isLoading (index) {
      return this.loading.includes(index)
    },
    getPercent (row) {
      let percent = (row.count / row.progress) * 100

      return isNaN(percent) ? 0 : percent
    },
    getType (row) {
      return this.getPercent(row) > 90 ? 'success' : 'warning'
    },
    getFileName (row) {
      if (row.file) {
        return row.file.name
      }

      return row.filename
    },
    getStatus (status) {
      switch (status) {
        case '-9':
          return 'Deleting'
        case '-8':
          return 'Resetting'
        case '-7':
          return 'Pending Deletion'
        case '-6':
          return 'Pending Reset'
        case '-5':
          return 'Error Deleting'
        case '-4':
          return 'Error Resetting'
        case '-2':
          return 'Error Importing'
        case '-1':
          return 'Error Validating'
        case '0':
          return 'Pending Reset'
        case '1':
          return 'Queued'
        case '2':
          return 'Validating'
        case '3':
          return 'Validated'
        case '4':
          return 'Importing'
        case '5':
          return 'Imported'
        case '6':
          return 'Invoiced'
      }
    },
    handleActionCommand ({ action, scope }) {
      action(scope.$index)
    },
    async refreshImport (row) {
      this.loading.push(row)
      await this.imports[row].refresh()
      this.loading.splice(this.loading.indexOf(row), 1)
    },
    deleteImport (row) {
      this.imports[row].status = -7
      this.imports[row].save()
    },
    resetImport (row) {
      this.imports[row].status = -6
      this.imports[row].save()
    },
    downloadImport (row) {
      this.$file.download(this.imports[row].file.id)
    }
  }
}
</script>
<style>
.el-table .error-row {
    background: rgb(253, 226, 226);
}
</style>
